<template>
	<div class="parent">
		<b class="largetext" v-bind:id="timeTableID+'header'">WEEK {{searchDate}}</b>
		<table>
            <thead>
				<th width="50px">Hour</th>
				<th>Mon, {{getDate(1)}}</th>
				<th>Tue, {{getDate(2)}}</th>
				<th>Wed, {{getDate(3)}}</th>
				<th>Thu, {{getDate(4)}}</th>
				<th>Fri, {{getDate(5)}}</th>
				<th>Sat, {{getDate(6)}}</th>
				<th>Sun, {{getDate(7)}}</th>
			</thead>
			<tbody>
				<tr id="row_header">
					<td style="text-align:right; padding-right:2px;">
						0
					</td>

					<template v-for="r in 7">
						<td rowspan="24">
							<div class="blockcontainer">
								<div v-for="(data, j) in column_data" class="blockcontainer" v-bind:id="timeTableID+'container-'+r+j" v-bind:style="'width:calc(100%/'+column_data.length+'); float:right;'">

								</div>
							</div>
						</td>
					</template>
				</tr>
				<tr v-for="hour in 23">
					<td style="text-align:right; padding-right:2px;">
						{{hour}}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
        id: Number,
		timeTableID: Number,
		employeeIDS: Array,
		searchDate: String,
		showEmpty: Boolean,
    },
	data() {
		return {
			column_names: [],
			column_data:[],
			heightValue:Array(2),
			topValue:Array(2),
		}
	},
	async created () {
		this.search();
	},
	methods: {
		getDate(day){
			var millis = 86400000;
			var date = new Date(this.searchDate);
			var dayNum = date.getDay();
			var dayOne = date.getTime() - (millis*dayNum)
			var endDate = new Date();
			endDate.setTime(dayOne+(millis*day));
			return(endDate.getFullYear()+"-"+(endDate.getMonth()+1)+"-"+endDate.getDate());
		},
		search (){
			this.column_data=[];
			var promises = [];
			for(var i = 0;i<this.employeeIDS.length;i++){
				promises.push(api.postData(
	                {
	                    type:"search",
	                    data:{
							pageid:this.id,
							showEmpty:this.showEmpty,
							data:[
		                        this.employeeIDS[i],
								this.searchDate,
		                    ]
						}
	                }
	            ).then((res) => {
		            this.column_names = res.data.data.column_names;
					if(this.showEmpty){
						this.column_data.push(res.data.data.column_data);
					}else{
						if(res.data.data.column_data.length>0 && res.data.data.column_data[0].length>0){
							console.log("DATA")
							console.log(res.data.data.column_data)
							this.column_data.push(res.data.data.column_data);
						}
					}
		        }));
			}

			Promise.all(promises).then((results) => {
				console.log(this.column_data)
				this.manageData();
			})
		},
		clearResults(){

		},
		manageData(){
			for(let j = 0;j<this.column_data.length;j++){
				this.heightValue[j]=[];
				this.topValue[j]=[];
				for(let i = 0;i<7;i++){
					this.heightValue[j][i]=[];
					this.topValue[j][i]=[];
				}

				var previousNum = -1;
				var iterator = 0;
				for(let i = 0; i<this.column_data[j].length;i++){
					var day = this.column_data[j][i][3]-1;
					if(isNaN(day)){
						continue;
					}

					if(previousNum==day) {
						iterator++;
					}else{
						iterator=0;
					}

					this.topValue[j][day][iterator]=[Math.floor((this.column_data[j][i][4]/100)*720)];
					this.heightValue[j][day][iterator]=[Math.ceil((this.column_data[j][i][5]/100)*720)];

					previousNum=day;
				}
			}
			this.setData();
		},
		setData(){
			for(let j = 0;j<this.column_data.length;j++){
				var iterator = 0;
				for(let i = 0;i<7;i++){

					var parent = document.getElementById(this.timeTableID+'container-'+(i+1)+''+j);
					while (parent.firstChild) {
						parent.removeChild(parent.lastChild);
					}

					for(let k = 0;k<this.heightValue[j][i].length;k++){
						var newChild = document.createElement("div");

						var color = this.column_data[j][iterator][12];
						var borderColor = this.column_data[j][iterator][13];
						var textColor = this.column_data[j][iterator][14];


						var textStyle = ' \
							font-size:12px; \
							margin-bottom:-5px; \
							margin-left:2px; \
							margin-top:0px; \
							font-color:#'+textColor+'; \
						';

						var style = ' \
							height:'+this.heightValue[j][i][k]+'px; \
							top:'+this.topValue[j][i][k]+'px; \
							position:absolute; \
							margin:auto; \
							right:5px; \
							left:5px; \
							background-color: #'+color+'; \
							border: 1px solid #'+borderColor+'; \
							border-top:3px solid #'+borderColor+'; \
							border-radius: 5px 5px 5px 5px; \
						';

						newChild.innerHTML = " \
						<p style='"+textStyle+"'>"+
							this.column_data[j][iterator][6]+", "+
							this.column_data[j][iterator][1]+", "+
							this.column_data[j][iterator][7].substr(0,20)+", "+
							this.column_data[j][iterator][8].substr(0,15)+", "+
							this.column_data[j][iterator][15]+"</p> \
						";

						var press = this.press;

						newChild.setAttribute('style', style);
						newChild.setAttribute('id', this.timeTableID+"timedata"+iterator);
						newChild.setAttribute('class', "time");
						newChild.setAttribute('title', this.column_data[j][iterator][16]+", "+this.column_data[j][iterator][10]);
						newChild.onclick = function(){press(j,i,k)};
						parent.appendChild(newChild);

						iterator++;
					}
				}
			}

			document.getElementById(this.timeTableID+'header').innerHTML="WEEK "+this.searchDate;
		},
		press(z,x,y){
			var iterator = 0;
			for(let i = 0;i<7;i++){
				for(let j = 0;j<this.heightValue[z][i].length;j++){
					if(i==x && j==y){
						router.push('/0301?q=11-'+this.column_data[z][iterator][6]);
						return;
					}
					iterator++;
				}
			}
		}
	},
	watch:{
		searchDate: function(newValue, oldValue) {
			this.search();
		},
		showEmpty: function(){
			this.search();
		}
	},
}
</script>

<style scoped>
table{
	table-layout: fixed ;
}

table,td {
	background-color: #ffffff;
	empty-cells: show;
}

thead{
	background: #d0d0d0;
	position:static;
	top:0px;
}

td{
	padding:0px;
}

td:nth-child(1){
	height:30px;
	font-size: 12px;
}

.blockcontainer{
	position:relative;
	height:720px;
	margin:0px;
	padding:0px;

	background-size: 10px 30px;
	background-image:
	linear-gradient(to bottom, #f0f0f0 1px, transparent 1px);
}

.time{
	opacity:.5;
}

.largetext{
	font-size:32px;
	margin-left:0px;
}

.parent{
	display:flex;
	max-width:100%;
	margin:auto;
	margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/timetable_overview.vue